import { EnvConfig } from '@connect-x-app/shared-types';
import { create } from 'zustand';

type EnvConfigSessionStoreSntate = {
  env: EnvConfig | null;
  setEnv: (env: EnvConfig) => void;
};

export const useEnvConfigSessionStore = create<EnvConfigSessionStoreSntate>(set => ({
  env: null,
  setEnv: env => set({ env }),
}));
